<section class="estatisticas-cadastro">
    <app-painel-comissoes
        [tituloPainel]="obterSecaoSelecionada().label"
        [descricaoPainel]="obterSecaoSelecionada().descricao"
        [iconePainel]="obterSecaoSelecionada().icon"
        [filtrosTemplate]="dashFiltros"
        [conteudoTemplate]="dashConteudo"
        [ocultarFiltros]="!!analiticoSelecionado"
    >
        <ng-template #dashFiltros>
            <label class="mapa-filtro">
                <span class="mapa-filtro-label">UF da comissão</span>
                <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfChange($event)"></app-estado-select>
            </label>
            <label class="mapa-filtro" for="gestao-comissoes-data-inicio">
                <span class="mapa-filtro-label">Período Inicial</span>
                <p-datepicker id="gestao-comissoes-data-inicio" [(ngModel)]="dataInicioDate" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" styleClass="ano-input-picker"></p-datepicker>
            </label>
            <label class="mapa-filtro" for="gestao-comissoes-data-fim">
                <span class="mapa-filtro-label">Período Final</span>
                <p-datepicker id="gestao-comissoes-data-fim" [(ngModel)]="dataFimDate" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" styleClass="ano-input-picker"></p-datepicker>
            </label>
            <div class="filtros-acoes">
                <p-button icon="pi pi-refresh" label="Atualizar" type="button" [loading]="carregando" (onClick)="carregarDashboard()"></p-button>
                <p-button icon="pi pi-filter-slash" label="Restaurar padrão" type="button" severity="secondary" [outlined]="true" title="Volta o período para o ano corrente" (onClick)="limparFiltros()"></p-button>
            </div>
        </ng-template>

        <ng-template #dashConteudo>
            @if (analiticoSelecionado) {
                <app-detalhamento-pendencias
                    [indicador]="obterIndicadorAnalitico()"
                    [linhas]="linhasAnalitico"
                    [first]="firstAnalitico"
                    [rows]="rowsAnalitico"
                    [totalRecords]="totalRegistrosAnalitico"
                    [carregando]="carregandoAnalitico"
                    [rotuloVoltar]="'Voltar'"
                    [voltarNoCard]="true"
                    [permitirVisualizacaoCard]="true"
                    [colunaUf]="analiticoSelecionado.colunaUf"
                    [colunaIdentificador]="analiticoSelecionado.colunaIdentificador"
                    [colunaNome]="analiticoSelecionado.colunaNome"
                    [colunaSituacao]="analiticoSelecionado.colunaSituacao"
                    [colunaDetalhe]="analiticoSelecionado.colunaDetalhe"
                    [provedorExportacao]="provedorExportacaoAnalitico"
                    [nomeArquivoExportacao]="analiticoSelecionado.indicador.titulo"
                    (voltar)="voltarParaGraficos()"
                    (paginaAlterada)="onPageChangeAnalitico($event)"
                >
                    <section detalhamento-filtros class="analitico-filtros-card">
                        <div class="analitico-filtros-card-header">
                            <span class="analitico-filtros-card-icon">
                                <i class="pi pi-filter"></i>
                            </span>
                            <h3 class="analitico-filtros-card-title">Filtros</h3>
                        </div>

                        <label class="analitico-filtro" for="gestao-comissoes-grupo-analitico">
                            <span class="mapa-filtro-label">Indicador</span>
                            <select id="gestao-comissoes-grupo-analitico" class="analitico-select" [ngModel]="grupoAnaliticoCodigo" (ngModelChange)="onGrupoAnaliticoChange($event)">
                                @for (opcao of obterOpcoesGrupoAnalitico(); track opcao.codigo) {
                                    <option [ngValue]="opcao.codigo">{{ obterDescricaoItem(opcao) }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro mapa-filtro-curto" for="gestao-comissoes-codigo-reuniao" [hidden]="!exibirFiltrosReuniaoAnalitico()">
                            <span class="mapa-filtro-label">Reunião</span>
                            <input id="gestao-comissoes-codigo-reuniao" class="dashboard-input" type="number" min="1" [(ngModel)]="codigoReuniaoFiltro" />
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-status-reuniao" [hidden]="!exibirFiltrosReuniaoAnalitico()">
                            <span class="mapa-filtro-label">Status reunião</span>
                            <select id="gestao-comissoes-status-reuniao" class="analitico-select" [(ngModel)]="idStatusReuniaoFiltro">
                                @for (opcao of opcoesStatusReuniao; track opcao.label) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-tipo-comissao" [hidden]="!exibirFiltrosComissaoAnalitico()">
                            <span class="mapa-filtro-label">Tipo</span>
                            <select id="gestao-comissoes-tipo-comissao" class="analitico-select" [(ngModel)]="idTipoComissaoCtFiltro">
                                @for (opcao of opcoesTiposComissao; track opcao.label) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro mapa-filtro-curto" for="gestao-comissoes-estrutura" [hidden]="!exibirFiltrosComissaoAnalitico()">
                            <span class="mapa-filtro-label">Comissão</span>
                            <input id="gestao-comissoes-estrutura" class="dashboard-input" type="number" min="1" [(ngModel)]="idEstruturaOrganizacionalFiltro" />
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-status-ata" [hidden]="!exibirFiltrosAtaAnalitico()">
                            <span class="mapa-filtro-label">Status ata</span>
                            <select id="gestao-comissoes-status-ata" class="analitico-select" [(ngModel)]="idStatusAtaFiltro">
                                @for (opcao of opcoesStatusAta; track opcao.label) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-local" [hidden]="!exibirFiltrosReuniaoAnalitico()">
                            <span class="mapa-filtro-label">Local</span>
                            <select id="gestao-comissoes-local" class="analitico-select" [(ngModel)]="idLocalReuniaoFiltro">
                                @for (opcao of opcoesLocaisReuniao; track opcao.label) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-convocacao" [hidden]="!exibirFiltrosConvocacaoAnalitico()">
                            <span class="mapa-filtro-label">Convocação</span>
                            <select id="gestao-comissoes-convocacao" class="analitico-select" [(ngModel)]="tipoConvocacaoFiltro">
                                @for (opcao of opcoesConvocacao; track opcao.value) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-marcacao-ata" [hidden]="!exibirFiltrosAtaAnalitico()">
                            <span class="mapa-filtro-label">Ata</span>
                            <select id="gestao-comissoes-marcacao-ata" class="analitico-select" [(ngModel)]="marcacaoAtaFiltro">
                                @for (opcao of opcoesMarcacaoAta; track opcao.value) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro mapa-filtro-curto" for="gestao-comissoes-assistente-id" [hidden]="!exibirFiltrosReuniaoAnalitico()">
                            <span class="mapa-filtro-label">Assistente</span>
                            <input id="gestao-comissoes-assistente-id" class="dashboard-input" type="number" min="1" [(ngModel)]="idSolicitanteAssistenteFiltro" />
                        </label>

                        <label class="mapa-filtro mapa-filtro-uf" for="gestao-comissoes-assistente-uf" [hidden]="!exibirFiltrosReuniaoAnalitico()">
                            <span class="mapa-filtro-label">UF ass.</span>
                            <input id="gestao-comissoes-assistente-uf" class="dashboard-input" type="text" maxlength="2" [(ngModel)]="ufSolicitanteAssistenteFiltro" />
                        </label>

                        <label class="mapa-filtro mapa-filtro-curto" for="gestao-comissoes-membro-id" [hidden]="!exibirFiltrosConvocacaoAnalitico()">
                            <span class="mapa-filtro-label">Membro</span>
                            <input id="gestao-comissoes-membro-id" class="dashboard-input" type="number" min="1" [(ngModel)]="idMembroConvidadoFiltro" />
                        </label>

                        <label class="mapa-filtro mapa-filtro-uf" for="gestao-comissoes-membro-uf" [hidden]="!exibirFiltrosConvocacaoAnalitico()">
                            <span class="mapa-filtro-label">UF mem.</span>
                            <input id="gestao-comissoes-membro-uf" class="dashboard-input" type="text" maxlength="2" [(ngModel)]="ufMembroConvidadoFiltro" />
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-situacao-atividade" [hidden]="!exibirFiltrosAtividadeAnalitico()">
                            <span class="mapa-filtro-label">Situação atividade</span>
                            <select id="gestao-comissoes-situacao-atividade" class="analitico-select" [(ngModel)]="idSituacaoTarefaFiltro">
                                @for (opcao of opcoesSituacaoAtividade; track opcao.label) {
                                    <option [ngValue]="opcao.value">{{ opcao.label }}</option>
                                }
                            </select>
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-encerramento-inicio" [hidden]="!exibirFiltrosAtividadeAnalitico()">
                            <span class="mapa-filtro-label">Encerramento Inicial</span>
                            <p-datepicker id="gestao-comissoes-encerramento-inicio" [(ngModel)]="dataInicioEncerramentoDate" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" styleClass="ano-input-picker"></p-datepicker>
                        </label>

                        <label class="mapa-filtro" for="gestao-comissoes-encerramento-fim" [hidden]="!exibirFiltrosAtividadeAnalitico()">
                            <span class="mapa-filtro-label">Encerramento Final</span>
                            <p-datepicker id="gestao-comissoes-encerramento-fim" [(ngModel)]="dataFimEncerramentoDate" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" styleClass="ano-input-picker"></p-datepicker>
                        </label>

                        <label class="mapa-filtro mapa-filtro-curto" for="gestao-comissoes-responsavel-id" [hidden]="!exibirFiltrosAtividadeAnalitico()">
                            <span class="mapa-filtro-label">Responsável</span>
                            <input id="gestao-comissoes-responsavel-id" class="dashboard-input" type="number" min="1" [(ngModel)]="idResponsavelAtividadeFiltro" />
                        </label>

                        <label class="mapa-filtro mapa-filtro-uf" for="gestao-comissoes-responsavel-uf" [hidden]="!exibirFiltrosAtividadeAnalitico()">
                            <span class="mapa-filtro-label">UF resp.</span>
                            <input id="gestao-comissoes-responsavel-uf" class="dashboard-input" type="text" maxlength="2" [(ngModel)]="ufResponsavelAtividadeFiltro" />
                        </label>

                        <label class="mapa-filtro mapa-filtro-descricao" for="gestao-comissoes-descricao-atividade" [hidden]="!exibirFiltrosAtividadeAnalitico()">
                            <span class="mapa-filtro-label">Descrição atividade</span>
                            <input id="gestao-comissoes-descricao-atividade" class="dashboard-input" type="text" [(ngModel)]="descricaoAtividadeFiltro" />
                        </label>

                        <div class="filtros-acoes">
                            <p-button icon="pi pi-filter" label="Aplicar" type="button" [loading]="carregandoAnalitico" (onClick)="aplicarFiltrosAnalitico()"></p-button>
                            <p-button icon="pi pi-filter-slash" label="Limpar" type="button" severity="secondary" [outlined]="true" (onClick)="limparFiltrosAnalitico()"></p-button>
                        </div>
                    </section>
                </app-detalhamento-pendencias>
            } @else {
                @if (avisoPaginacao) {
                    <div class="aviso-dashboard">
                        <i class="pi pi-info-circle"></i>
                        <span>{{ avisoPaginacao }}</span>
                    </div>
                }

                <section class="indicadores-grid" aria-label="Indicadores executivos">
                    @if (carregando) {
                        @for (item of [1, 2, 3, 4]; track item) {
                            <div class="card-entrada card-entrada-1 indicador-card">
                                <p-skeleton width="100%" height="220px"></p-skeleton>
                            </div>
                        }
                    } @else {
                        @for (indicador of indicadores; track indicador.titulo; let idx = $index) {
                            <div class="card-entrada card-entrada-1 indicador-card" [ngClass]="indicador.classe">
                                <app-card-content [title]="indicador.titulo" [subtitle]="indicador.legenda" [icon]="indicador.icon">
                                    <div card-header class="flex items-center gap-2">
                                        @if (indicador.analiticoTipo) {
                                            <p-button icon="pi pi-table" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Ver analítico" ariaLabel="Ver analítico" (onClick)="abrirAnaliticoCard(indicador)"></p-button>
                                        }
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('indicador-' + idx)"></p-button>
                                    </div>
                                    <div class="estatistica-total-bloco">
                                        <span class="estatistica-total-valor">{{ indicador.valor }}</span>
                                        <span class="estatistica-total-label">registros</span>
                                    </div>
                                </app-card-content>
                            </div>
                        }
                    }
                </section>

                @if (subsecaoAtiva('reunioes', 'visao-geral')) {
                    <section class="agenda-grid" aria-label="Agenda de reuniões">
                        <div class="card-entrada card-entrada-2 agenda-card">
                            <app-card-content [title]="'Próxima reunião'" [subtitle]="'Próximo compromisso previsto dentro do período filtrado.'" [icon]="'pi pi-calendar-plus'">
                                <div card-header class="flex items-center gap-2">
                                    <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('proxima-reuniao')"></p-button>
                                </div>
                                <div class="estatistica-total-bloco agenda-total">
                                    @if (resumo?.dataProximaReuniao) {
                                        <span class="agenda-data">{{ formatarDataHora(resumo?.dataProximaReuniao) }}</span>
                                        <span class="estatistica-total-label">Código {{ resumo?.codigoProximaReuniao || '-' }}</span>
                                    } @else {
                                        <span class="agenda-vazio">Nenhuma reunião prevista no período filtrado.</span>
                                    }
                                </div>
                            </app-card-content>
                        </div>

                        <div class="card-entrada card-entrada-2 agenda-card">
                            <app-card-content [title]="'Última reunião'" [subtitle]="'Último compromisso identificado dentro do período filtrado.'" [icon]="'pi pi-calendar-minus'">
                                <div card-header class="flex items-center gap-2">
                                    <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('ultima-reuniao')"></p-button>
                                </div>
                                <div class="estatistica-total-bloco agenda-total">
                                    @if (resumo?.dataUltimaReuniao) {
                                        <span class="agenda-data">{{ formatarDataHora(resumo?.dataUltimaReuniao) }}</span>
                                        <span class="estatistica-total-label">Código {{ resumo?.codigoUltimaReuniao || '-' }}</span>
                                    } @else {
                                        <span class="agenda-vazio">Nenhuma reunião registrada no período filtrado.</span>
                                    }
                                </div>
                            </app-card-content>
                        </div>
                    </section>
                }

                @if (subsecaoAtiva('reunioes', 'visao-geral')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Visão geral</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content
                                    [title]="'Indicadores operacionais por etapa'"
                                    [subtitle]="'Reuniões em cada etapa (convocação, confirmação, ata, protocolo); as etapas são independentes, não um funil estrito.'"
                                    [icon]="'pi pi-sitemap'"
                                >
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('funil')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('funil')"></p-button>
                                    </div>
                                    <div class="estatistica-total-bloco">
                                        <span class="estatistica-total-valor">{{ totalReunioes | number }}</span>
                                        <span class="estatistica-total-label">reuniões</span>
                                    </div>
                                    <div class="estatistica-lista">
                                        @if (carregando) {
                                            @for (linha of [1, 2, 3, 4, 5]; track linha) {
                                                <div class="estatistica-linha">
                                                    <div class="estatistica-linha-texto">
                                                        <p-skeleton width="130px" height="16px"></p-skeleton>
                                                        <p-skeleton width="100%" height="4px"></p-skeleton>
                                                    </div>
                                                    <p-skeleton width="56px" height="20px"></p-skeleton>
                                                </div>
                                            }
                                        } @else if (funilOperacional.length) {
                                            @for (etapa of funilOperacional; track etapa.label) {
                                                <div class="estatistica-linha">
                                                    <div class="estatistica-linha-texto">
                                                        <span class="estatistica-item-descricao">{{ etapa.label }}</span>
                                                        <span class="estatistica-barra"><span [style.width.%]="etapa.percentual"></span></span>
                                                    </div>
                                                    <span class="estatistica-item-total">{{ etapa.total | number }}</span>
                                                </div>
                                            }
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Evolução mensal de reuniões'" [subtitle]="'Quantidade de reuniões por mês no período filtrado.'" [icon]="'pi pi-chart-line'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-evolucao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-evolucao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="reunioesEvolucaoData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('reunioes', 'distribuicao')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Distribuição</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por status'" [subtitle]="'Distribuição das reuniões por situação operacional.'" [icon]="'pi pi-chart-pie'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-status')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-status')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="reunioesStatusData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por modalidade'" [subtitle]="'Distribuição entre reuniões presenciais, virtuais ou híbridas.'" [icon]="'pi pi-chart-pie'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('modalidade')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('modalidade')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="modalidadeData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por tipo de comissão'" [subtitle]="'Distribuição das reuniões por tipo de comissão, câmara ou grupo.'" [icon]="'pi pi-objects-column'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-tipo-comissao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-tipo-comissao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="reunioesTipoComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('reunioes', 'operacao')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Operação</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por local'" [subtitle]="'Top 10 locais com mais reuniões no período filtrado.'" [icon]="'pi pi-map-marker'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-local')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-local')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="reunioesLocalData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões visíveis no portal'" [subtitle]="'Distribuição das reuniões conforme visibilidade no portal.'" [icon]="'pi pi-globe'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-portal')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-portal')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <app-razao [itens]="dadosReunioesPortal"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Agenda futura por semana'" [subtitle]="'Reuniões agendadas ou remarcadas para as próximas semanas.'" [icon]="'pi pi-calendar'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('agenda-semanal')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('agenda-semanal')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAgendaSemanal > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="agendaSemanalData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem reuniões futuras</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por faixa de duração'" [subtitle]="'Distribuição das reuniões com duração registrada por faixa de duração.'" [icon]="'pi pi-stopwatch'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-duracao-faixa')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-duracao-faixa')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioesDuracaoFaixa > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="reunioesDuracaoFaixaData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Duração média por modalidade'" [subtitle]="'Duração média, em minutos, por modalidade das reuniões com horário de término.'" [icon]="'pi pi-clock'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-duracao-modalidade')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioesDuracaoModalidade > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="reunioesDuracaoModalidadeData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por local interno x externo'" [subtitle]="'Proporção de reuniões (exceto canceladas) em locais internos e externos.'" [icon]="'pi pi-building'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-window-maximize"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Maximizar"
                                            ariaLabel="Maximizar"
                                            (onClick)="maximizarGrafico('reunioes-local-interno-externo')"
                                        ></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioesLocalInternoExterno > 0) {
                                            <app-razao [itens]="dadosReunioesLocalInternoExterno"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('atas', 'visao-geral')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Visão geral</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Produção mensal de atas'" [subtitle]="'Atas preenchidas por mês no período filtrado.'" [icon]="'pi pi-file-edit'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atas-producao-mensal')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atas-producao-mensal')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtasProducaoMensal > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atasProducaoMensalData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atas por status'" [subtitle]="'Acompanhamento das atas vinculadas às reuniões filtradas.'" [icon]="'pi pi-file-edit'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atas-status')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atas-status')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="atasStatusData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('atas', 'qualidade')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Qualidade</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atas com e sem protocolo'" [subtitle]="'Distribuição das atas conforme vínculo com protocolo.'" [icon]="'pi pi-link'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atas-protocolo')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atas-protocolo')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtasProtocolo > 0) {
                                            <app-razao [itens]="dadosAtasProtocolo"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atas importantes'" [subtitle]="'Distribuição das atas marcadas como importantes.'" [icon]="'pi pi-flag'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atas-importancia')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atas-importancia')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalReunioes > 0) {
                                            <app-razao [itens]="dadosAtasImportancia"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atas por faixa de lead time'" [subtitle]="'Distribuição das atas publicadas por faixa de lead time entre o fim da reunião e a publicação da ata.'" [icon]="'pi pi-hourglass'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atas-lead-time-faixa')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atas-lead-time-faixa')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtasLeadTimeFaixa > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atasLeadTimeFaixaData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Lead time médio de ata por comissão'" [subtitle]="'Ranking das comissões com maior lead time médio de publicação de ata.'" [icon]="'pi pi-clock'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atas-lead-time-comissao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtasLeadTimeComissao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atasLeadTimeComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('convocacoes', 'confirmacao')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Convocação & confirmação</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Taxa de confirmação por reunião'" [subtitle]="'Reuniões com convocação ordenadas por percentual de confirmação.'" [icon]="'pi pi-chart-bar'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('confirmacoes')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('confirmacoes')"></p-button>
                                    </div>
                                    <div class="estatistica-total-bloco">
                                        <span class="estatistica-total-valor">{{ confirmacoesRanking.length | number }}</span>
                                        <span class="estatistica-total-label">{{ confirmacoesRanking.length === 1 ? 'reunião' : 'reuniões' }}</span>
                                    </div>
                                    <div class="estatistica-lista">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (confirmacoesRanking.length) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="confirmacoesData" [options]="horizontalBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem reuniões com convocação</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Pendências de convocação'" [subtitle]="'Reuniões com convocação ou confirmação pendente.'" [icon]="'pi pi-send'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('pendencias-convocacao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('pendencias-convocacao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalPendenciasConvocacao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="pendenciasConvocacaoData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem pendências</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Envio de e-mails de convocação'" [subtitle]="'E-mails de convocação enviados e não enviados.'" [icon]="'pi pi-envelope'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('convocacoes-emails')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-emails')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoEmails > 0) {
                                            <app-razao [itens]="dadosConvocacaoEmails"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Confirmações por meio'" [subtitle]="'Distribuição das confirmações registradas por meio de confirmação.'" [icon]="'pi pi-comments'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('convocacoes-meio')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-meio')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoMeio > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="convocacaoMeioData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'SMS de convocação por status de envio'" [subtitle]="'Distribuição dos SMS de convocação enviados por status de envio.'" [icon]="'pi pi-mobile'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('convocacoes-sms-status')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-sms-status')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoSmsStatus > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="convocacaoSmsStatusData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Convocações: e-mail x SMS'" [subtitle]="'Comparativo de volume entre convocações enviadas por e-mail e por SMS.'" [icon]="'pi pi-send'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-email-sms')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoEmailSms > 0) {
                                            <app-razao [itens]="dadosConvocacaoEmailSms"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('convocacoes', 'presenca-atos')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Presença & atos</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Presenças por tipo'" [subtitle]="'Distribuição das presenças registradas nas reuniões filtradas.'" [icon]="'pi pi-check-square'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('convocacoes-presencas')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-presencas')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoPresencas > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="convocacaoPresencasData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atos de concessão por comissão'" [subtitle]="'Top 10 comissões por soma de atos de concessão no período.'" [icon]="'pi pi-ticket'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-atos-comissao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-atos-comissao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtosComissao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atosComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem atos de concessão</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atos de concessão: com x sem'" [subtitle]="'Reuniões com e sem atos de concessão no período.'" [icon]="'pi pi-ticket'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('reunioes-atos-distribuicao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('reunioes-atos-distribuicao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtosDistribuicao > 0) {
                                            <app-razao [itens]="dadosAtosDistribuicao"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Quórum médio por comissão'" [subtitle]="'Top 10 comissões por quórum médio de presença nas reuniões.'" [icon]="'pi pi-percentage'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('quorum-medio-comissao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('quorum-medio-comissao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalQuorumMedioComissao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="quorumMedioComissaoData" [options]="horizontalBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Reuniões por faixa de quórum'" [subtitle]="'Distribuição das reuniões por faixa de quórum de presença.'" [icon]="'pi pi-percentage'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('quorum-faixa')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('quorum-faixa')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalQuorumFaixa > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="quorumFaixaData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Passagens emitidas por mês'" [subtitle]="'Confirmações com emissão de passagem, agrupadas por mês da reunião.'" [icon]="'pi pi-send'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-passagens-mes')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoPassagensMes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="convocacaoPassagensMesData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Convidados mais frequentes'" [subtitle]="'Ranking das pessoas presentes que não eram membros vigentes da comissão na data da reunião.'" [icon]="'pi pi-user-plus'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('convocacoes-convidados')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('convocacoes-convidados')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoConvidados > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="convocacaoConvidadosData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem convidados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Reuniões com vs sem convidados'" [subtitle]="'Reuniões que tiveram ao menos um convidado presente, em comparação às sem convidados.'" [icon]="'pi pi-users'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-window-maximize"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Maximizar"
                                            ariaLabel="Maximizar"
                                            (onClick)="maximizarGrafico('convocacoes-reunioes-convidados')"
                                        ></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalConvocacaoReunioesConvidados > 0) {
                                            <app-razao [itens]="dadosConvocacaoReunioesConvidados"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('atividades', 'visao-geral')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Visão geral</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Evolução mensal de atividades'" [subtitle]="'Atividades abertas por mês no período filtrado.'" [icon]="'pi pi-chart-line'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atividades-evolucao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-evolucao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesEvolucao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atividadesEvolucaoData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atividades por situação'" [subtitle]="'Atividades vinculadas ao módulo por situação atual.'" [icon]="'pi pi-briefcase'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atividades-situacao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-situacao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividades > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atividadesSituacaoData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atividades por prazo'" [subtitle]="'Atividades atrasadas, no prazo ou concluídas.'" [icon]="'pi pi-clock'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atividades-prazo')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-prazo')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesPrazo > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atividadesPrazoData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content
                                    [title]="'Tarefas por faixa de prazo planejado'"
                                    [subtitle]="'Tarefas concluídas agrupadas pelo intervalo (dias) entre início e término previsto — reflete o prazo planejado, não a data real de conclusão.'"
                                    [icon]="'pi pi-hourglass'"
                                >
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atividades-tempo-conclusao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-tempo-conclusao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesTempoConclusao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atividadesTempoConclusaoData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Tarefas: vinculadas x avulsas'" [subtitle]="'Tarefas vinculadas a uma reunião em comparação às avulsas.'" [icon]="'pi pi-link'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-origem')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesOrigem > 0) {
                                            <app-razao [itens]="dadosAtividadesOrigem"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Tarefas: com x sem protocolo'" [subtitle]="'Tarefas com protocolo vinculado em comparação às sem protocolo.'" [icon]="'pi pi-file'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-protocolo')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesProtocolo > 0) {
                                            <app-razao [itens]="dadosAtividadesProtocolo"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('atividades', 'distribuicao')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Distribuição</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atividades por responsável'" [subtitle]="'Top 10 responsáveis com mais atividades no período filtrado.'" [icon]="'pi pi-user-edit'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atividades-responsavel')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-responsavel')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesResponsavel > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atividadesResponsavelData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Atividades por comissão'" [subtitle]="'Top 10 comissões com mais atividades no período filtrado.'" [icon]="'pi pi-chart-bar'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('atividades-comissao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('atividades-comissao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalAtividadesComissao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="atividadesComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('membros', 'composicao')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Composição</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3 card-hero">
                                <app-card-content [title]="'Membros por UF'" [subtitle]="'Distribuição dos membros vigentes por unidade da federação.'" [icon]="'pi pi-map'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('membros-uf')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-uf')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosUf > 0) {
                                            <div class="membros-uf-horizontal-layout">
                                                @for (item of obterMembrosUfItens(); track item.codigo ?? item.descricao ?? item.ordem) {
                                                    @let ufMembro = obterUfMembro(item);
                                                    <div class="membros-uf-linha">
                                                        @if (obterBandeiraUf(ufMembro); as bandeiraUf) {
                                                            <img [src]="bandeiraUf" [alt]="ufMembro" class="membros-uf-bandeira" />
                                                        }
                                                        <div class="membros-uf-linha-conteudo">
                                                            <div class="membros-uf-linha-dados">
                                                                <span class="membros-uf-linha-nome">{{ ufMembro || obterDescricaoItem(item) }}</span>
                                                                <span class="membros-uf-linha-total">{{ item.total ?? 0 | number }}</span>
                                                            </div>
                                                            <span class="membros-uf-linha-barra"><span [style.width]="obterLarguraBarraMembrosUf(item)"></span></span>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Membros por participação'" [subtitle]="'Distribuição dos membros vigentes por tipo de participação.'" [icon]="'pi pi-users'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('membros-participacao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-participacao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosParticipacao > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="membrosParticipacaoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Membros por nº de comissões'" [subtitle]="'Distribuição dos membros ativos por quantidade de comissões vigentes.'" [icon]="'pi pi-sitemap'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('membros-multivinculo')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-multivinculo')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosMultivinculo > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="membrosMultivinculoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Membros ativos x afastados'" [subtitle]="'Distribuição dos membros entre ativos e afastados.'" [icon]="'pi pi-user-minus'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('membros-status')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-status')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosStatus > 0) {
                                            <app-razao [itens]="dadosMembrosStatus"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Entradas de membros por mês'" [subtitle]="'Novos vínculos de membros, agrupados pelo mês de início.'" [icon]="'pi pi-user-plus'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-entradas-mes')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosEntradasMes > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="membrosEntradasMesData" [options]="barOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Tempo médio de mandato por tipo (meses)'" [subtitle]="'Meses médios de mandato dos vínculos encerrados, por tipo de comissão.'" [icon]="'pi pi-hourglass'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-mandato-tipo')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosMandatoTipo > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="bar" [data]="membrosMandatoTipoData" [options]="horizontalCountBarOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Membros por status (histórico)'" [subtitle]="'Distribuição do histórico de status registrado para os membros.'" [icon]="'pi pi-history'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-status-historico')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosStatusHistorico > 0) {
                                            <div class="estatistica-grafico-container">
                                                <p-chart type="doughnut" [data]="membrosStatusHistoricoData" [options]="doughnutOptions"></p-chart>
                                            </div>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (subsecaoAtiva('membros', 'conformidade')) {
                    <div class="secao-bloco">
                        <span class="bloco-eyebrow">Conformidade</span>
                        <div class="estatisticas-grid">
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Membros por status LGPD'" [subtitle]="'Distribuição dos membros vigentes conforme aceite da LGPD.'" [icon]="'pi pi-shield'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('membros-lgpd')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-lgpd')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosLgpd > 0) {
                                            <app-razao [itens]="dadosMembrosLgpd"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                            <div class="card-entrada card-entrada-3">
                                <app-card-content [title]="'Membros por quitação de débitos'" [subtitle]="'Distribuição dos membros vigentes conforme quitação financeira.'" [icon]="'pi pi-credit-card'">
                                    <div card-header class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-table"
                                            styleClass="botao-topo-acao"
                                            [text]="true"
                                            [rounded]="true"
                                            title="Visualizar dados estatísticos"
                                            ariaLabel="Visualizar dados estatísticos"
                                            (onClick)="selecionarAnalitico('membros-quitacao')"
                                        ></p-button>
                                        <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('membros-quitacao')"></p-button>
                                    </div>
                                    <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                        @if (carregando) {
                                            <p-skeleton width="100%" height="210px"></p-skeleton>
                                        } @else if (totalMembrosQuitacao > 0) {
                                            <app-razao [itens]="dadosMembrosQuitacao"></app-razao>
                                        } @else {
                                            <div class="estatistica-sem-dados">Sem dados</div>
                                        }
                                    </div>
                                </app-card-content>
                            </div>
                        </div>
                    </div>
                }
                @if (secaoAtiva('comissoes')) {
                    @if (subsecaoAtiva('comissoes', 'perfil')) {
                        <div class="secao-bloco">
                            <span class="bloco-eyebrow">Perfil</span>
                            <div class="estatisticas-grid">
                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões por tipo'" [subtitle]="'Top 10 tipos de comissão por quantidade de estruturas.'" [icon]="'pi pi-sitemap'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-table"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Visualizar dados estatísticos"
                                                ariaLabel="Visualizar dados estatísticos"
                                                (onClick)="selecionarAnalitico('comissoes-tipo')"
                                            ></p-button>
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-tipo')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesTipo > 0) {
                                                <div class="estatistica-grafico-container">
                                                    <p-chart type="bar" [data]="comissoesTipoData" [options]="horizontalCountBarOptions"></p-chart>
                                                </div>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Entidades externas por representantes'" [subtitle]="'Top 10 entidades externas por número de representantes vigentes.'" [icon]="'pi pi-building-columns'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-table"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Visualizar dados estatísticos"
                                                ariaLabel="Visualizar dados estatísticos"
                                                (onClick)="selecionarAnalitico('comissoes-entidades-externas')"
                                            ></p-button>
                                            <p-button
                                                icon="pi pi-window-maximize"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Maximizar"
                                                ariaLabel="Maximizar"
                                                (onClick)="maximizarGrafico('comissoes-entidades-externas')"
                                            ></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesEntidadesExternas > 0) {
                                                <div class="estatistica-grafico-container">
                                                    <p-chart type="bar" [data]="comissoesEntidadesExternasData" [options]="horizontalCountBarOptions"></p-chart>
                                                </div>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões com vs sem núcleos'" [subtitle]="'Comissões vigentes com pelo menos uma estrutura-núcleo vinculada, em comparação às sem núcleo.'" [icon]="'pi pi-share-alt'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-window-maximize"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Maximizar"
                                                ariaLabel="Maximizar"
                                                (onClick)="maximizarGrafico('comissoes-com-sem-nucleos')"
                                            ></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesComSemNucleos > 0) {
                                                <app-razao [itens]="dadosComissoesComSemNucleos"></app-razao>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Núcleos ativos x encerrados'" [subtitle]="'Situação das estruturas-núcleo vinculadas às comissões.'" [icon]="'pi pi-sitemap'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-window-maximize"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Maximizar"
                                                ariaLabel="Maximizar"
                                                (onClick)="maximizarGrafico('comissoes-nucleos-situacao')"
                                            ></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesNucleosSituacao > 0) {
                                                <app-razao [itens]="dadosComissoesNucleosSituacao"></app-razao>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões por faixa de nº de membros'" [subtitle]="'Distribuição das comissões vigentes pela quantidade de membros vigentes.'" [icon]="'pi pi-users'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-table"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Visualizar dados estatísticos"
                                                ariaLabel="Visualizar dados estatísticos"
                                                (onClick)="selecionarAnalitico('comissoes-faixa-membros')"
                                            ></p-button>
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-faixa-membros')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesFaixaMembros > 0) {
                                                <div class="estatistica-grafico-container">
                                                    <p-chart type="bar" [data]="comissoesFaixaMembrosData" [options]="barOptions"></p-chart>
                                                </div>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões com vs sem coordenador'" [subtitle]="'Comissões vigentes com coordenador vigente designado, em comparação às sem coordenador.'" [icon]="'pi pi-user'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-coordenador')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesCoordenador > 0) {
                                                <app-razao [itens]="dadosComissoesCoordenador"></app-razao>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões por antiguidade'" [subtitle]="'Anos desde a portaria de inclusão das comissões vigentes.'" [icon]="'pi pi-hourglass'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-antiguidade')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesAntiguidade > 0) {
                                                <div class="estatistica-grafico-container">
                                                    <p-chart type="bar" [data]="comissoesAntiguidadeData" [options]="barOptions"></p-chart>
                                                </div>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>
                            </div>
                        </div>
                    }

                    @if (subsecaoAtiva('comissoes', 'situacao')) {
                        <div class="secao-bloco">
                            <span class="bloco-eyebrow">Situação</span>
                            <div class="estatisticas-grid">
                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões ativas x inativas'" [subtitle]="'Distribuição das comissões entre ativas e inativas/extintas.'" [icon]="'pi pi-power-off'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-table"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Visualizar dados estatísticos"
                                                ariaLabel="Visualizar dados estatísticos"
                                                (onClick)="selecionarAnalitico('comissoes-status')"
                                            ></p-button>
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-status')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesStatus > 0) {
                                                <app-razao [itens]="dadosComissoesStatus"></app-razao>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões extintas por ano'" [subtitle]="'Quantidade de comissões extintas, agrupada por ano da portaria de remoção.'" [icon]="'pi pi-calendar-times'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-table"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Visualizar dados estatísticos"
                                                ariaLabel="Visualizar dados estatísticos"
                                                (onClick)="selecionarAnalitico('comissoes-extintas-ano')"
                                            ></p-button>
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-extintas-ano')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesExtintasAno > 0) {
                                                <div class="estatistica-grafico-container">
                                                    <p-chart type="bar" [data]="comissoesExtintasAnoData" [options]="barOptions"></p-chart>
                                                </div>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>

                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Vida média por tipo'" [subtitle]="'Anos médios entre a portaria de inclusão e a de remoção das comissões extintas, por tipo.'" [icon]="'pi pi-hourglass'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-window-maximize"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Maximizar"
                                                ariaLabel="Maximizar"
                                                (onClick)="maximizarGrafico('comissoes-vida-media-tipo')"
                                            ></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesVidaMediaTipo > 0) {
                                                <div class="estatistica-grafico-container">
                                                    <p-chart type="bar" [data]="comissoesVidaMediaTipoData" [options]="horizontalCountBarOptions"></p-chart>
                                                </div>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>
                            </div>
                        </div>
                    }

                    @if (subsecaoAtiva('comissoes', 'agenda-futura')) {
                        <div class="secao-bloco">
                            <span class="bloco-eyebrow">Agenda futura</span>
                            <div class="estatisticas-grid">
                                <div class="card-entrada card-entrada-3 card-hero">
                                    <app-card-content [title]="'Comissões sem reunião futura'" [subtitle]="'Comissões ativas com e sem reunião agendada futura.'" [icon]="'pi pi-calendar-times'">
                                        <div card-header class="flex items-center gap-2">
                                            <p-button
                                                icon="pi pi-table"
                                                styleClass="botao-topo-acao"
                                                [text]="true"
                                                [rounded]="true"
                                                title="Visualizar dados estatísticos"
                                                ariaLabel="Visualizar dados estatísticos"
                                                (onClick)="selecionarAnalitico('comissoes-sem-reuniao')"
                                            ></p-button>
                                            <p-button icon="pi pi-window-maximize" styleClass="botao-topo-acao" [text]="true" [rounded]="true" title="Maximizar" ariaLabel="Maximizar" (onClick)="maximizarGrafico('comissoes-sem-reuniao')"></p-button>
                                        </div>
                                        <div class="estatistica-lista h-full flex flex-col justify-center min-h-[220px]">
                                            @if (carregando) {
                                                <p-skeleton width="100%" height="210px"></p-skeleton>
                                            } @else if (totalComissoesSemReuniao > 0) {
                                                <app-razao [itens]="dadosComissoesSemReuniao"></app-razao>
                                            } @else {
                                                <div class="estatistica-sem-dados">Sem dados</div>
                                            }
                                        </div>
                                    </app-card-content>
                                </div>
                            </div>
                        </div>
                    }
                }

                @if (secaoAtiva('conselheiros')) {
                    <app-conselheiros-estatisticas [dataInicio]="dataInicio" [dataFim]="dataFim" [uf]="ufSelecionada"></app-conselheiros-estatisticas>
                }

                <p-dialog
                    appDialogoPadrao="pi pi-users"
                    descricao="Indicador em tela cheia."
                    [(visible)]="exibirModalMaximizados"
                    [header]="obterTituloCardMaximizado()"
                    [style]="{ width: '75vw', maxWidth: '1000px' }"
                    [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
                    [dismissableMask]="true"
                    (onHide)="cardMaximizadoId = null"
                    styleClass="modal-estatistica-custom"
                >
                    @if (cardMaximizadoId) {
                        <div class="estatistica-card modal-card-wrapper">
                            <div class="modal-visualizacao-conteudo">
                                @if (cardMaximizadoId.startsWith('indicador-')) {
                                    @let ind = obterIndicadorPorId(cardMaximizadoId);
                                    @if (ind) {
                                        <div class="estatistica-total-bloco modal-kpi">
                                            <span class="estatistica-total-valor" style="font-size: 3rem">{{ ind.valor }}</span>
                                            <span class="estatistica-total-label" style="font-size: 1.2rem">registros</span>
                                        </div>
                                    }
                                }

                                @if (cardMaximizadoId === 'proxima-reuniao') {
                                    <div class="estatistica-total-bloco agenda-total modal-kpi">
                                        <span class="agenda-data" style="font-size: 2.5rem">{{ formatarDataHora(resumo?.dataProximaReuniao) }}</span>
                                        <span class="agenda-total-label" style="font-size: 1rem; margin-top: 0.5rem">Código {{ resumo?.codigoProximaReuniao || '-' }}</span>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'ultima-reuniao') {
                                    <div class="estatistica-total-bloco agenda-total modal-kpi">
                                        <span class="agenda-data" style="font-size: 2.5rem">{{ formatarDataHora(resumo?.dataUltimaReuniao) }}</span>
                                        <span class="agenda-total-label" style="font-size: 1rem; margin-top: 0.5rem">Código {{ resumo?.codigoUltimaReuniao || '-' }}</span>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'funil') {
                                    <div class="modal-lista-scroll">
                                        @for (etapa of funilOperacional; track etapa.label) {
                                            <div class="estatistica-linha">
                                                <div class="estatistica-linha-texto">
                                                    <span class="estatistica-item-descricao">{{ etapa.label }}</span>
                                                    <span class="estatistica-barra"><span [style.width.%]="etapa.percentual"></span></span>
                                                </div>
                                                <span class="estatistica-item-total">{{ etapa.total | number }}</span>
                                            </div>
                                        }
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-status') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="reunioesStatusData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-evolucao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="reunioesEvolucaoData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-tipo-comissao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="reunioesTipoComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atas-status') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="atasStatusData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atas-protocolo') {
                                    <div class="modal-razao"><app-razao [itens]="dadosAtasProtocolo"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'modalidade') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="modalidadeData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-atos-comissao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atosComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-atos-distribuicao') {
                                    <div class="modal-razao"><app-razao [itens]="dadosAtosDistribuicao"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'quorum-medio-comissao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="quorumMedioComissaoData" [options]="horizontalBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'quorum-faixa') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="quorumFaixaData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-local') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="reunioesLocalData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-duracao-faixa') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="reunioesDuracaoFaixaData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-duracao-modalidade') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="reunioesDuracaoModalidadeData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'reunioes-local-interno-externo') {
                                    <div class="modal-razao"><app-razao [itens]="dadosReunioesLocalInternoExterno"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'reunioes-portal') {
                                    <div class="modal-razao"><app-razao [itens]="dadosReunioesPortal"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'atas-importancia') {
                                    <div class="modal-razao"><app-razao [itens]="dadosAtasImportancia"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'atas-lead-time-faixa') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atasLeadTimeFaixaData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atas-lead-time-comissao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atasLeadTimeComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'agenda-semanal') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="agendaSemanalData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atas-producao-mensal') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atasProducaoMensalData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atividades-evolucao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atividadesEvolucaoData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'pendencias-convocacao') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="pendenciasConvocacaoData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atividades-situacao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atividadesSituacaoData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atividades-responsavel') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atividadesResponsavelData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atividades-prazo') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atividadesPrazoData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atividades-tempo-conclusao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atividadesTempoConclusaoData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'atividades-origem') {
                                    <div class="modal-razao"><app-razao [itens]="dadosAtividadesOrigem"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'atividades-protocolo') {
                                    <div class="modal-razao"><app-razao [itens]="dadosAtividadesProtocolo"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'confirmacoes') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="confirmacoesData" [options]="horizontalBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'membros-lgpd') {
                                    <div class="modal-razao"><app-razao [itens]="dadosMembrosLgpd"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'membros-quitacao') {
                                    <div class="modal-razao"><app-razao [itens]="dadosMembrosQuitacao"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'membros-participacao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="membrosParticipacaoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'membros-multivinculo') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="membrosMultivinculoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'membros-status') {
                                    <div class="modal-razao"><app-razao [itens]="dadosMembrosStatus"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'membros-uf') {
                                    <div class="membros-uf-horizontal-layout membros-uf-horizontal-layout-modal">
                                        @for (item of obterMembrosUfItens(); track item.codigo ?? item.descricao ?? item.ordem) {
                                            @let ufMembro = obterUfMembro(item);
                                            <div class="membros-uf-linha">
                                                @if (obterBandeiraUf(ufMembro); as bandeiraUf) {
                                                    <img [src]="bandeiraUf" [alt]="ufMembro" class="membros-uf-bandeira" />
                                                }
                                                <div class="membros-uf-linha-conteudo">
                                                    <div class="membros-uf-linha-dados">
                                                        <span class="membros-uf-linha-nome">{{ ufMembro || obterDescricaoItem(item) }}</span>
                                                        <span class="membros-uf-linha-total">{{ item.total ?? 0 | number }}</span>
                                                    </div>
                                                    <span class="membros-uf-linha-barra"><span [style.width]="obterLarguraBarraMembrosUf(item)"></span></span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }

                                @if (cardMaximizadoId === 'membros-entradas-mes') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="membrosEntradasMesData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'membros-mandato-tipo') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="membrosMandatoTipoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'membros-status-historico') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="membrosStatusHistoricoData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-presencas') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="convocacaoPresencasData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-emails') {
                                    <div class="modal-razao"><app-razao [itens]="dadosConvocacaoEmails"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-passagens-mes') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="convocacaoPassagensMesData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-meio') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="convocacaoMeioData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-sms-status') {
                                    <div class="modal-grafico-container modal-grafico-pizza">
                                        <p-chart type="doughnut" [data]="convocacaoSmsStatusData" [options]="doughnutOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-email-sms') {
                                    <div class="modal-razao"><app-razao [itens]="dadosConvocacaoEmailSms"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-convidados') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="convocacaoConvidadosData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'convocacoes-reunioes-convidados') {
                                    <div class="modal-razao"><app-razao [itens]="dadosConvocacaoReunioesConvidados"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'comissoes-tipo') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="comissoesTipoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'comissoes-status') {
                                    <div class="modal-razao"><app-razao [itens]="dadosComissoesStatus"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'comissoes-sem-reuniao') {
                                    <div class="modal-razao"><app-razao [itens]="dadosComissoesSemReuniao"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'comissoes-extintas-ano') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="comissoesExtintasAnoData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'comissoes-entidades-externas') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="comissoesEntidadesExternasData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'comissoes-vida-media-tipo') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="comissoesVidaMediaTipoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'comissoes-com-sem-nucleos') {
                                    <div class="modal-razao"><app-razao [itens]="dadosComissoesComSemNucleos"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'comissoes-faixa-membros') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="comissoesFaixaMembrosData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'comissoes-coordenador') {
                                    <div class="modal-razao"><app-razao [itens]="dadosComissoesCoordenador"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'comissoes-antiguidade') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="comissoesAntiguidadeData" [options]="barOptions"></p-chart>
                                    </div>
                                }

                                @if (cardMaximizadoId === 'comissoes-nucleos-situacao') {
                                    <div class="modal-razao"><app-razao [itens]="dadosComissoesNucleosSituacao"></app-razao></div>
                                }

                                @if (cardMaximizadoId === 'atividades-comissao') {
                                    <div class="modal-grafico-container">
                                        <p-chart type="bar" [data]="atividadesComissaoData" [options]="horizontalCountBarOptions"></p-chart>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </p-dialog>
            }
        </ng-template>
    </app-painel-comissoes>
</section>
